import React, { useRef } from 'react';

const VerificationCodeInput = ({ code, setCode }: { code: string; setCode: (code: string) => void }) => {
  const inputs = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value.replace(/\D/g, '');
    if (!value) return;

    const newCode = code.split('');
    newCode[index] = value[0];
    setCode(newCode.join('').slice(0, 6));

    if (value && index < 5) {
      inputs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace') {
      if (code[index]) {
        const newCode = code.split('');
        newCode[index] = '';
        setCode(newCode.join(''));
      } else if (index > 0) {
        inputs.current[index - 1]?.focus();
      }
    }
  };

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      {Array(6).fill(0).map((_, i) => (
        <input
          key={i}
          ref={(el) => { inputs.current[i] = el; }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={code[i] || ''}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          style={{
            width: '40px',
            height: '50px',
            textAlign: 'center',
            fontSize: '24px',
            border: '1px solid #ccc',
            borderRadius: '6px'
          }}
        />
      ))}
    </div>
  );
};

export default VerificationCodeInput;
